import "./settings.css"

export default function Settings() {
	return <></>
}
